import * as React from 'react';
import MuiAccordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Chip, SxProps } from '@mui/material';

const chipStyle: SxProps = {
  borderRadius: 1,
  color: 'primary.contrastText',
  backgroundColor: 'primary.main',
  fontWeight: 'bold',
  height: 24,
  padding: 1,
  '& .MuiChip-label': {
    padding: 0,
    height: 'auto'
  }
};

type Props = {
  children: React.ReactNode;
  title: string | React.ReactNode;
  disabledExpansion?: boolean;
  count?: number;
  disabled?: boolean;
  onClick?: () => void;
};

/** @deprecated */
export const Accordion: React.FC<Props> = ({
  children,
  title,
  disabledExpansion,
  count,
  disabled,
  onClick
}) => {
  return (
    <MuiAccordion disableGutters disabled={disabled} onChange={onClick}>
      <AccordionSummary
        expandIcon={
          disabledExpansion || disabled ? null : <KeyboardArrowDownIcon />
        }
        aria-controls="panel1-content"
        id="panel1-header"
        sx={{
          pointerEvents: disabledExpansion ? 'none' : 'auto' // Prevent interactions when disabled,
        }}
      >
        {Number.isInteger(count) && <Chip sx={chipStyle} label={count} />}
        {typeof title === 'string' && <Typography>{title}</Typography>}
        {typeof title !== 'string' && <>{title}</>}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </MuiAccordion>
  );
};
